import React from "react";
import Input from "../Form/Input/Input";

class DropdownToggle extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    if (!this.props.readonly) {
      this.props.onClick(e);
    }
  }

  render() {
    return (
      <div ref={this.props.innerRef} onClick={this.handleClick}>
        <Input
          disabled
          {...this.props}
          as={"select"}
          value={this.props.value}
        />
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => (
  <DropdownToggle innerRef={ref} {...props} />
));
